export const PHISHING_BADGE_ACTIONS = {
  confirm: 'confirm',
  reject: 'reject',
};

export const HANDLED_ERRORS = [
  'badge.token_expired',
  'badge.token_invalid',
];
